
import { Component, Vue } from 'vue-property-decorator';

import FormModule from '@/store/modules/form';
import { getStateSelectorItems } from '@/utils/global.util';

@Component({})
export default class FoundationApplicationForm extends Vue {
  formModel: {
    organization: string;
    address: string;
    city: string;
    state: string;
    zip: number | null;
    nonProfitStatus: string[] | null;
    firstName: string;
    lastName: string;
    jobTitle: string;
    phone: string;
    email: string;
    missionStatement: string;
    pillarsServed: string[] | null;
    pillarsMoreInformation: string;
    projectName: string;
    locationServed: string;
    individualsServed: string;
    projectMoreInformation: string;
    amountRequested: string;
    amountRequestedMoreInformation: string;
    hasPreviousFunding: boolean;
    previousFundingMoreInformation: string;
  };

  data() {
    return {
      formModel: {
        organization: '',
        address: '',
        city: '',
        state: '',
        zip: null,
        nonProfitStatus: null,
        firstName: '',
        lastName: '',
        jobTitle: '',
        phone: '',
        email: '',
        missionStatement: '',
        pillarsServed: null,
        pillarsMoreInformation: '',
        projectName: '',
        locationServed: '',
        individualsServed: '',
        projectMoreInformation: '',
        amountRequested: '',
        amountRequestedMoreInformation: '',
        hasPreviousFunding: false,
        previousFundingMoreInformation: '',
      }
    }
  }

  get states() {
    return getStateSelectorItems();
  }

  get nonProfitStatuses() {
    return ['501 (c)(3)', 'Charity', 'Tax exempt under section 170(c)', 'Educational Organization'];
  }

  get pillars() {
    return ['Youth Education', 'Health/Wellness', 'Hunger']
  }

  get redirectUrl() {
    return window?.__INITIAL_STATE__?.thankYouUrl;
  }

  get hasPreviousFunding() {
    return this.formModel.hasPreviousFunding;
  }

  async submitHandler(formModel) {
    const loader = this.$loading.show();
    try {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('foundationapplication');

      await FormModule.submitFoundationApplication({ ...formModel, recaptchaToken: token } as FoundationApplicationRequest)
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl
      } else {
        this.$toasted.success('Your submission has been received!');
        this.formModel = {
          organization: '',
          address: '',
          city: '',
          state: '',
          zip: null,
          nonProfitStatus: null,
          firstName: '',
          lastName: '',
          jobTitle: '',
          phone: '',
          email: '',
          missionStatement: '',
          pillarsServed: null,
          pillarsMoreInformation: '',
          projectName: '',
          locationServed: '',
          individualsServed: '',
          projectMoreInformation: '',
          amountRequested: '',
          amountRequestedMoreInformation: '',
          hasPreviousFunding: false,
          previousFundingMoreInformation: '',
        };
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }
}
